const ERROR_MAP = {
  'OW':          'Only owner can perform this action',
  'OA':          'Only admin can perform this action',
  'OOA':         'Only owner or admin can perform this action',
  'OL':          'Contract not linked yet — owner must set Authorized Logic/Admin on Storage',
  'OS':          'Only authorized spender can call this',
  'REG':         'Address already registered',
  'NR':          'User not registered',
  'IR':          'Invalid referrer',
  'IP':          'Invalid package',
  'IL':          'Invalid level',
  'IM':          'Invalid milestone',
  'IA':          'Invalid address',
  'IV':          'Invalid value',
  'BL':          'User is blacklisted',
  'NA':          'User is not active',
  'NIL':         'Nothing to claim',
  'CB':          'Insufficient claimable balance',
  'EB':          'Insufficient expense balance',
  'AD0':         'No active directs to decrement',
  'EX':          'User already exists',
  'PROT':        'Protected user (owner/admin)',
  'NF':          'User not found',
  'AR':          'Already rewarded',
  'NE':          'Not eligible',
  'EMPTY':       'Pool is empty',
  'NO_ELIGIBLE': 'No eligible users',
  'SMALL':       'Amount too small to distribute',
  'PRICE':       'ZENOVA price is not set — admin must configure it before claims can pay out',
  'TINY':        'Amount too small to convert to ZENOVA',
  'TF':          'Token transfer failed — the contract likely does not have enough ZENOVA/USDC reserve to pay out. Ask admin to top up.',
  'SUM':         'Sum must total 100%',
  'F50':         'Fee cannot exceed 50%',
  'P100':        'Percentage cannot exceed 100%',
  'MIN':         'Below minimum bound',
  'MAX':         'Above maximum bound',
  'NOID':        'Could not generate ID'
};

// Try every field ethers/wallets stuff a revert reason into
const digForReason = (err, depth = 0) => {
  if (!err || depth > 6) return null;
  if (typeof err === 'string') return err;

  // ethers v5 common shapes
  if (err.reason) return err.reason;
  if (err.error && err.error.reason) return err.error.reason;
  if (err.data && typeof err.data === 'string' && err.data.startsWith('0x')) return err.data;
  if (err.data && err.data.message) return err.data.message;
  if (err.error && err.error.data && err.error.data.message) return err.error.data.message;
  if (err.error && err.error.message) return err.error.message;
  if (err.data && err.data.originalError && err.data.originalError.message) return err.data.originalError.message;
  if (err.message) return err.message;

  // Some providers nest under body / result
  if (err.body) return err.body;
  if (err.result) return err.result;

  return null;
};

const tryDecodeShortCode = (text) => {
  if (!text) return null;
  // Look for a quoted short code at end, e.g. reverted: 'TF' or execution reverted: TF
  const patterns = [
    /reverted:?\s*['"]?([A-Z0-9_]{2,20})['"]?\s*$/i,
    /reason string ['"]([A-Z0-9_]{2,20})['"]/i,
    /['"]([A-Z0-9_]{2,20})['"]/,
    /:\s*([A-Z0-9_]{2,20})\s*$/
  ];
  for (const rx of patterns) {
    const m = text.match(rx);
    if (m && ERROR_MAP[m[1]]) return ERROR_MAP[m[1]];
  }
  return null;
};

export const parseError = (err) => {
  if (!err) return 'Unknown error';

  // User rejected
  const code = err.code;
  if (code === 4001 || code === 'ACTION_REJECTED') {
    return 'Transaction rejected by user';
  }

  const raw = digForReason(err) || '';
  const clean = String(raw).replace(/^execution reverted:?\s*/i, '').trim();

  // Direct short-code match
  if (ERROR_MAP[clean]) return ERROR_MAP[clean];

  // Fuzzy short-code extraction
  const mapped = tryDecodeShortCode(clean);
  if (mapped) return mapped;

  // Common wallet / RPC errors — clean-language versions
  const lower = clean.toLowerCase();
  if (lower.includes('insufficient funds')) return 'Insufficient funds for gas';
  if (lower.includes('nonce')) return 'Nonce error — please retry';
  if (lower.includes('gas required exceeds')) return 'Gas estimation failed — transaction would revert';
  if (lower.includes('network changed')) return 'Network changed during transaction';
  if (lower.includes('user denied') || lower.includes('user rejected')) return 'Transaction rejected by user';

  // Cryptic RPC failures — surface as a helpful hint
  if (lower.includes('rpc request failed') || lower.includes('failed to fetch') ||
      (lower.includes('eth_estimategas') && lower.includes('failed'))) {
    return 'Transaction would revert. Likely causes: contract not linked yet, insufficient ZENOVA reserve to pay out, ZENOVA price not set, or nothing to claim.';
  }

  if (lower.includes('call revert exception') || lower.includes('cannot estimate gas')) {
    return 'Transaction would revert — check that you meet all requirements (balance, allowance, eligibility).';
  }

  return clean.length > 200 ? clean.slice(0, 200) + '...' : (clean || 'Transaction failed');
};
